import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, scale: 0.985, filter: "blur(6px)" }}
    whileInView={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 1.05, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterHead = ({ badge, title, note, dark = false }) => (
  <div className="relative mb-14 md:mb-20">
    <Reveal>
      <div className="flex items-center gap-5 mb-4">
        <span className={`font-mono2 font-bold text-sm md:text-base tracking-[0.18em] uppercase ${dark ? "text-[#FFF1E4]" : "text-[#E8431F]"}`}>{badge}</span>
        <span className={`h-px flex-1 ${dark ? "bg-white/25" : "bg-[#33181F]/15"}`} />
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-[-0.02em] max-w-[18ch]">
        {title}
      </h2>
    </Reveal>
    {note && (
      <Reveal delay={0.16}>
        <p className={`mt-7 max-w-[54ch] text-base md:text-lg leading-relaxed ${dark ? "text-white/70" : "text-[#5F5258]"}`}>
          {note}
        </p>
      </Reveal>
    )}
  </div>
);
